/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseProducerDataWidgetConfigurationModel extends models.BaseDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("BaseProducerDataWidgetConfigurationModel");
    }

    getFixupPrototypeFunction() { return BaseProducerDataWidgetConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<BaseProducerDataWidgetConfigurationModel>): BaseProducerDataWidgetConfigurationModel {
        let obj = Object.assign(new BaseProducerDataWidgetConfigurationModel(), model);
        BaseProducerDataWidgetConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseProducerDataWidgetConfigurationModel>): BaseProducerDataWidgetConfigurationModel {
        if (!model) return null;
        return BaseProducerDataWidgetConfigurationModel.newInstance(<BaseProducerDataWidgetConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseProducerDataWidgetConfigurationModel) {
        if (!obj) return;

        models.BaseProducerDataWidgetConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseProducerDataWidgetConfigurationModel): boolean {
        if (models.BaseDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseProducerDataWidgetConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    contextId: string;

}
